import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// 引入 vConsole 调试工具（仅在需要时启用）
if (typeof window !== 'undefined' && (process.env.NODE_ENV === 'development' || window.location.search.includes('debug=true'))) {
  import('vconsole').then((VConsole) => {
    new VConsole.default(); // 直接实例化，不需要赋值给变量
    console.log('vConsole loaded successfully');
  });
}

// 引入 FontAwesome 相关模块
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// 按需导入 Element Plus 组件
import {
  ElRadioGroup,
  ElRadioButton,
  ElRadio, // 添加 ElRadio 导入
  ElForm,
  ElFormItem,
  ElInput,
  ElInputNumber,
  ElSelect,
  ElOption,
  ElDialog,
  ElCheckbox,
  ElButton,
  ElMessage,
  ElLoading, // 添加 ElLoading 导入
  ElTag, // 添加 ElTag 导入
  ElMenu, // 添加 ElMenu 导入
  ElMenuItem, // 添加 ElMenuItem 导入
  ElSubMenu, // 添加 ElSubMenu 导入
  ElAvatar, // 添加 ElAvatar 导入
  ElAlert, // 添加 ElAlert 导入
  ElIcon, // 添加 ElIcon 导入
  ElCard, // 添加 ElCard 导入
  ElTable, // 添加 ElTable 导入
  ElTableColumn, // 添加 ElTableColumn 导入
  ElPagination, // 添加 ElPagination 导入
  ElRow, // 添加 ElRow 导入
  ElCol, // 添加 ElCol 导入
  ElSlider // 添加 ElSlider 导入
} from 'element-plus'
import 'element-plus/dist/index.css'

// 引入 Font Awesome CSS 样式
import '@fortawesome/fontawesome-free/css/all.min.css'

// 添加 FontAwesome 图标到库中
library.add(fas, far, fab)

const app = createApp(App)
const pinia = createPinia()

// 注册 FontAwesomeIcon 组件
app.component('font-awesome-icon', FontAwesomeIcon)

// 注册使用的 Element Plus 组件（确保名称不为空）
app.component(ElRadioGroup.name || 'el-radio-group', ElRadioGroup)
app.component(ElRadioButton.name || 'el-radio-button', ElRadioButton)
app.component(ElRadio.name || 'el-radio', ElRadio) // 注册单选按钮组件
app.component(ElForm.name || 'el-form', ElForm)
app.component(ElFormItem.name || 'el-form-item', ElFormItem)
app.component(ElInput.name || 'el-input', ElInput) // 注册输入框组件
app.component(ElInputNumber.name || 'el-input-number', ElInputNumber)
app.component(ElSelect.name || 'el-select', ElSelect)
app.component(ElOption.name || 'el-option', ElOption)
app.component(ElDialog.name || 'el-dialog', ElDialog)
app.component(ElCheckbox.name || 'el-checkbox', ElCheckbox)
app.component(ElButton.name || 'el-button', ElButton)
app.component(ElTag.name || 'el-tag', ElTag) // 注册标签组件
app.component(ElMenu.name || 'el-menu', ElMenu) // 注册菜单组件
app.component(ElMenuItem.name || 'el-menu-item', ElMenuItem) // 注册菜单项组件
app.component(ElSubMenu.name || 'el-sub-menu', ElSubMenu) // 注册子菜单组件
app.component(ElAvatar.name || 'el-avatar', ElAvatar) // 注册头像组件
app.component(ElAlert.name || 'el-alert', ElAlert) // 注册警告组件
app.component(ElIcon.name || 'el-icon', ElIcon) // 注册图标组件
app.component(ElCard.name || 'el-card', ElCard) // 注册卡片组件
app.component(ElTable.name || 'el-table', ElTable) // 注册表格组件
app.component(ElTableColumn.name || 'el-table-column', ElTableColumn) // 注册表格列组件
app.component(ElPagination.name || 'el-pagination', ElPagination) // 注册分页组件
app.component(ElRow.name || 'el-row', ElRow) // 注册行组件
app.component(ElCol.name || 'el-col', ElCol) // 注册列组件
app.component(ElSlider.name || 'el-slider', ElSlider) // 注册滑块组件

// 注册 v-loading 指令
app.directive('loading', ElLoading.directive)

// 全局挂载 ElMessage
app.config.globalProperties.$message = ElMessage

// 使用路由和Pinia
app.use(router).use(pinia)

app.mount('#app')
console.log('应用已挂载')